package com.eladfinish.bible.contest.common

class ChaptersRepository {

    companion object {
        const val PEOPLE_NAMES = "peopleNames"
        const val NAMES_PREFIX = "names"
        const val TXT = ".txt"
        private const val DELIMITER = "_"

        fun getFileFormat(number: Int, bookName: String, chapter: String): String =
            "_${number}$DELIMITER$bookName-$chapter.txt"

        fun getBookPrefix(number: Int, bookName: String): String =
            "_${number}$DELIMITER$bookName"

        fun getBookNumber(chapterFilename: String): Int {
            val underscore = chapterFilename.indexOf(string = DELIMITER, startIndex = 1)
            return chapterFilename.take(underscore).removePrefix(prefix = "_").toInt()
        }

        fun String.migrateFilename(): String {
            return this.takeUnless { it.contains(". ") } ?: this.replace(oldValue = ". ", newValue = DELIMITER)
        }

        fun padNumber(bookNameEnglish: String, chapterNum: Int): String {
            // endsWith because bookNameEnglish may start with a number and dot
            return chapterNum.toString().padStart(if (bookNameEnglish.endsWith(suffix = "tehilim")) 3 else 2, padChar = '0')
        }

        fun Int.padNumberExt(bookNameEnglish: String): String {
            return padNumber(bookNameEnglish = bookNameEnglish, chapterNum = this)
        }

    }

}
